import { message } from "antd";
import { jwtDecode } from "jwt-decode";

const hardcodeToken = "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJiZWEwODRmMS1iOWI0LTQ2ZGEtYjZiZi1kNDg1YjE2YWJjZGQiLCJuYW1lIjoiQXJlZWogWmFoaWQgQWxpIiwiaW1hZ2UiOiJodHRwczovL3dvcmt3LmNvbS9SZXNvdXJjZXNcXDBhYjVmOWMwLWY5NDgtNGM0MC04ZGFkLWM1OGJhOTlmYjc2NVxcSW1hZ2VzXFxiZGM2YmM1NC0wNjAwLTQxOGYtYTM0OS1mMDIyMWRhYjU2MGYuanBlZyIsImVtYWlsIjoiYXJlZWpAbWlsZXRhcC5jb20iLCJidXNpbmVzc0lkIjoiMGFiNWY5YzAtZjk0OC00YzQwLThkYWQtYzU4YmE5OWZiNzY1IiwidmVyIjoiODIzODlFQkMtMDA1OS00NEUzLUI1QjUtMUM0REU0NzcwQ0E1IiwiaWgiOiJpeks2QlgwSlZYRjZia3l5alFBcUJHZXlhQStkcmpSRnRrbVMyV0E3MTJFPSIsImlzIjoiaWFQMW9wd29xSTVtT2Q1Wk9XTHBqQT09IiwicGgiOiI3Y3JLTFRWaFphYWczYk01OVJsY2ZPUFBZNXgvUlludVNlY2ZxWmpNTkpJPSIsInBzIjoiZ2Mrei9DaU12V01LbHJIaFJLQ0tMZz09IiwiaXNBZ2VudCI6IkZhbHNlIiwianRpIjoiNDJmNGQ3NzItMWQ3Yi00NTA0LWIzOWUtNTUxODYzZDNjMzM0IiwibmJmIjoxNzc0Njg1OTE4LCJleHAiOjE3NzQ4NTg3MTh9.WSf7-NYkZWM2_ocHGaAPmSYti6yW_vias9B13QS5TX86XS3AvElCprXnhuykgEzZZwdasNnpNldM8szH622BwmKuGMgVMsnScfKOe-L_DN0DnKrpPZp-isJC39ZAswCbdM8kuqKn7kDl21Et-jMnYemiECFMy6Dj6eVkSCfJ5qvYsohsGbCh25hzSGhnZykN8A-czfsInjfNMqpyzKntqLhCxYGmbzGhrXfS7-03YazXpK-W9JpwTz7Jt-KZ23XsqkXU61MCf86tnlb4pkzwESLqOX_xd6CFp-hJw4G52KSdpiLo4jIGy4KaQH2oVvYSBzQFBLaG_XQAt3PzXBdkmA";

function getCookieValue(name) {
  const regex = new RegExp(`(^| )${name}=([^;]+)`)
  const match = document.cookie.match(regex)
  if (match) {
    return match[2]
  }
}

export function getWorkWiseAuthToken() {
  const searchParams = new URLSearchParams(document.location.search);
  let cookieToken = getCookieValue("token")
  let queryToken = searchParams.get("token");
  const finalToken = queryToken || cookieToken || hardcodeToken;
  return finalToken;
}

export const getUserInfoFromToken = () => {
  try {
    const token = getWorkWiseAuthToken();

    if (!token) return null;

    const decoded = jwtDecode(token);

    return decoded || null;
  } catch (error) {
    console.error("Invalid token:", error);
    return null;
  }
};

export function decodeWorkWiseToken() {
  const token = getWorkWiseAuthToken();
  if (!token) return null;
  try {
    const payload = token.split('.')[1];
    const decoded = JSON.parse(atob(payload));
    return decoded;
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
}

export function getSelectedData(sheet, selectedRange) {
  const { sri, sci, eri, eci } = selectedRange;
  const data = [];
  const headers = [];
  for (let ci = sci; ci <= eci; ci += 1) {
    const column = [];
    for (let ri = sri; ri <= eri; ri += 1) {
      const cell = sheet.data.getCell(ri, ci);
      const cellData = cell && typeof cell.text === 'string' ? cell.text.trim() : null;
      if (ri === sri) {
        headers.push(cellData || "");
        column.push(cellData || "");
      } else {
        column.push(cellData || "");
      }
    }
    if (column.length > 0) {
      data.push(column);
    }
  }
  let payload = {
    data: data,
    headers: headers
  }
  return payload;
}

export function findSheetName(sheets, text) {

  const sheetNames = sheets.map((sheet) => sheet.name);

  let maxCount = 0;
  const names = sheetNames && Array.isArray(sheetNames) && sheetNames.filter(name => name && name.includes(text));

  const counts = names.map(name => {
    const match = name.match(new RegExp(`${text} (\\d+)`));
    return match ? parseInt(match[1], 10) : 0;
  });

  maxCount = counts && Math.max(...counts);
  console.log('okkkk names', sheetNames, sheets, counts);

  let name = maxCount >= 0 ? `${text} ${maxCount + 1}` : `${text} 0`;

  return name;
}
export const formatFileSize = (bytes) => {
  if (bytes === 0) return "0 Bytes";

  const units = ["Bytes", "KB", "MB", "GB"];
  let size = bytes;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }

  if (unitIndex === 0) {
    return `${size} ${units[unitIndex]}`;
  } else if (unitIndex === 1 && size < 50) {
    return `${parseFloat(size.toFixed(0))} ${units[unitIndex]}`;
  } else {
    return `${parseFloat(size.toFixed(2))} ${units[unitIndex]}`;
  }
};
export const getWatermarkData = async () => {
  const now = new Date();
  const currentDateTime = now.toLocaleString();

  // Get IP address
  let ip = 'N/A';
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    ip = data.ip;
  } catch (error) {
    console.error("Error fetching IP:", error);
    message.error("Could not fetch IP address");
  }

  // Get location
  let location = { lat: 'N/A', lng: 'N/A' };
  try {
    location = await new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        message.error("Geolocation not supported");
        return resolve(location);
      }

      navigator.geolocation.getCurrentPosition(
        (position) => resolve({
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }),
        (error) => {
          handleGeolocationError(error);
          resolve(location); // Return default on error
        }
      );
    });
  } catch (error) {
    console.error("Location error:", error);
  }

  return {
    currentDateTime,
    ip,
    location
  };
};

const handleGeolocationError = (error) => {
  switch (error.code) {
    case error.PERMISSION_DENIED:
      message.error("Location access denied. Please enable permissions.");
      break;
    case error.POSITION_UNAVAILABLE:
      message.error("Location information unavailable.");
      break;
    case error.TIMEOUT:
      message.error("Location request timed out.");
      break;
    default:
      message.error("Unknown location error occurred.");
  }
};

export const processTemplateData = (serverResponse) => {
  let templateData = serverResponse?.data?.data || null;
  if (templateData?.milepadData) {
    try {
      const rawData = JSON.parse(templateData.milepadData);
      delete templateData.milepadData;
      templateData.spreadsheetData = rawData;
    } catch (error) {
      console.error('Failed to parse template milepadData:', error);
      delete templateData.milepadData;
      templateData.spreadsheetData = [];
    }
  }
  return templateData;
};